/* Name: handleFileSelection.tsx
* Copyright: (c) DA-Design Oy
* Creation date: 15.05.2024   (EKn)
*
* Description: 
*/

/* eslint-disable */
// @ts-nocheck

import { Box, Button, Typography} from '@mui/material';
import { ChangeEvent, useState } from 'react';
import { handleFileSasToken } from './handleFileSASToken';
import FileUpload from './handleFileUpload';

function FileSelection(props) {
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [sasTokenUrl, setSasTokenUrl] = useState<string>('');

    function handleFileSelection(event: ChangeEvent<HTMLInputElement>) {
        const { target } = event;
        if (!(target instanceof HTMLInputElement)) return;
        if (
        target?.files === null ||
        target?.files?.length === 0 ||
        target?.files[0] === null
        )
        return;

        // reset
        handleFileSasToken(target?.files[0])
            .then((result) =>{
                setSasTokenUrl(result.data.url);
                setSelectedFile(target?.files[0]);
            })
        
    }
  
    return (
        <Box
            display="block"
            justifyContent="left"
            alignItems="left"
            flexDirection="column"
            my={4}
        >
            <Button variant="contained" component="label">
            Select a file
            <input type="file" hidden onChange={handleFileSelection} />
            </Button>
            {selectedFile && selectedFile.name && (
            <Box my={2}>
                <Typography variant="body2">{selectedFile.name}</Typography>
            </Box>
            )}
            <FileUpload SasTokenUrl={sasTokenUrl} SelectedFile={selectedFile}/>
        </Box>
    );
};

export default FileSelection;
